import {
  AllowedRulesApi,
  ApiClient,
  AppointAnIntermediaryApi,
  ClientDetailsApi,
  CompanyDetailsApi,
  Configuration,
  DocumentsApi,
  EmploymentAndTaxApi,
  FinancialAndTaxApi,
  FitAndProperApi,
  IndividualDetailsApi,
  IntermediaryApi,
  InvestmentDetailsApi,
  JustPortfolioApi,
  LookupsApi,
  NonTaxableInstitutionDetailsApi,
  PaymentDetailsApi,
  PdfApi,
  ProductMatrixApi,
  ProductSelectionsApi,
  ProposalsInfosApi,
  ProposalsOverviewsApi,
  ProposalSummaryApi,
  ReportingApi,
  SecurityApi,
  SigningApi,
  ThirdPartiesApi,
  TrustDetailsApi,
  ExposureApi
} from 'bff';
export const initialiseApiClient = (apiConfig: Configuration): ApiClient => ({
  clientDetailsApi: new ClientDetailsApi(apiConfig),
  investmentDetailsApi: new InvestmentDetailsApi(apiConfig),
  proposalSummaryApi: new ProposalSummaryApi(apiConfig),
  lookupsApi: new LookupsApi(apiConfig),
  pdfApi: new PdfApi(apiConfig),
  individualDetailsApi: new IndividualDetailsApi(apiConfig),
  trustDetailsApi: new TrustDetailsApi(apiConfig),
  companyDetailsApi: new CompanyDetailsApi(apiConfig),
  nonTaxableInstitutionDetailsApi: new NonTaxableInstitutionDetailsApi(apiConfig),
  thirdPartiesApi: new ThirdPartiesApi(apiConfig),
  productMatrixApi: new ProductMatrixApi(apiConfig),
  productSelectionsApi: new ProductSelectionsApi(apiConfig),
  proposalsInfosApi: new ProposalsInfosApi(apiConfig),
  proposalsOverviewsApi: new ProposalsOverviewsApi(apiConfig),
  securityApi: new SecurityApi(apiConfig),
  allowedRulesApi: new AllowedRulesApi(apiConfig),
  appointAnIntermediaryApi: new AppointAnIntermediaryApi(apiConfig),
  signingApi: new SigningApi(apiConfig),
  employmentAndTaxDetailsApi: new EmploymentAndTaxApi(apiConfig),
  documentsApi: new DocumentsApi(apiConfig),
  paymentDetailsApi: new PaymentDetailsApi(apiConfig),
  intermediaryApi: new IntermediaryApi(apiConfig),
  fitAndProperApi: new FitAndProperApi(apiConfig),
  reportingApi: new ReportingApi(apiConfig),
  financialAndTaxApi: new FinancialAndTaxApi(apiConfig),
  exposureApi: new ExposureApi(apiConfig),
  justPortfolioApi: new JustPortfolioApi(apiConfig)
});
